export const getProfileTypeId = (profileTypeName) => {
  const profileTypes = {
    Companies: 1,
    'Design & Architecture Studios': 2,
    Museums: 7,
    'Design Organization': 8,
  };

  return profileTypes[profileTypeName];
};
